import { render, staticRenderFns } from "./QuilityRx.vue?vue&type=template&id=3ca0c91e&scoped=true&"
import script from "./QuilityRx.vue?vue&type=script&lang=js&"
export * from "./QuilityRx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0c91e",
  null
  
)

export default component.exports